import { render, staticRenderFns } from "./HerbUsageReport.vue?vue&type=template&id=06bebb5a"
import script from "./HerbUsageReport.vue?vue&type=script&lang=js"
export * from "./HerbUsageReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports